import { render } from "./ReportsDashboard.vue?vue&type=template&id=0db26ff2&scoped=true"
const script = {}

import "./ReportsDashboard.vue?vue&type=style&index=0&id=0db26ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db26ff2"]])

export default __exports__